import {t} from '@lingui/core/macro';

import {IColumn} from 'shared/ui/Table/Table';

import {DomainIncidentType} from '../model/DomainIncident/IDomainIncident';

export function getDomainIncidentColumns(hideDomain: boolean): IColumn[] {
    return [
        {label: t`Статус`, sort: 'resolved'},
        ...(hideDomain ? [] : [{label: t`Домен`, sort: 'domain'}]),
        {label: t`Причина`, sort: 'type'},
        {label: t`Дата возникновения`, sort: 'id'},
        {label: t`Решить до`, sort: 'expire_at'},
        {label: t`Дата решения`, sort: 'resolved_at'},
        {label: ''},
        {label: ''},
    ];
}

export const translateDomainIncidentCause = (type: DomainIncidentType, errorMessage?: string|null): string => {
    const map = {
        'robots-txt-differs-from-expected': t`Изменения в файле robots.txt`,
        'robots-txt-invalid-charset': t`В файле robots.txt используется недопустимая кодировка`,
        'robots-txt-incorrect-content-type': t`Для robots.txt указан неверный Content-Type`,

        'ssl-expired': t`Истекает срок SSL сертификата`,
        'ssl-redirect-missing': t`Не настроен редирект с http на https`,
        'domain-expired': t`Истекает срок регистрации домена`,
        'robots-txt-missing': t`Отсутствует файл robots.txt`,
        'robots-txt-restricted': t`Файл robots.txt не доступен для чтения`,
        'robots-txt-home-disallowed': t`Главная страница сайта закрыта от индексирования`,
        'robots-txt-site-map-not-specified': t`В файле robots.txt отсутствует ссылка на карту сайта`,
        'rkn-block': t`Сайт обнаружен в реестре запрещённых РКН`,
    };

    const cause = map[type];

    return errorMessage ? `${cause} (${errorMessage})` : cause;
};
